import { Grid } from '@mui/material';
import { StyledButtonConfirmar } from './styles';
import ButtonContent from './ButtonContent';

const ActionButton = ({
  isLoading,
  onClick,
  align,
  buttonText = 'Confirmar',
}) => {
  const handleClick = event => {
    if (isLoading) {
      event.preventDefault();
      return;
    }

    onClick?.(event);
  };

  return (
    <Grid
      item
      container
      sx={{ justifyContent: { xs: 'center', md: align || 'end' } }}
    >
      <StyledButtonConfirmar
        type="button"
        onClick={handleClick}
        disabled={isLoading}
        align={align}
      >
        <ButtonContent isLoading={isLoading}>{buttonText}</ButtonContent>
      </StyledButtonConfirmar>
    </Grid>
  );
};

export default ActionButton;
